import { getNpsGroupByScore } from 'entities/Surveys'
import { type ISurveyNpsGroup } from 'entities/Surveys/api/types'

export const NPS_PREVIEW_REPLY_SCORE = 6

const NPS_GROUP_CATEGORY_KEYS: Record<ISurveyNpsGroup, 'promoters' | 'passives' | 'detractors'> = {
  promoter: 'promoters',
  passive: 'passives',
  detractor: 'detractors',
}

export const getNpsCategoryKeyByScore = (score: number) =>
  NPS_GROUP_CATEGORY_KEYS[getNpsGroupByScore(score)]
